export enum InspectionType {
  appImportedInspection = 3,
  localInspection = 4,
  massiveImportedInspection = 6,
  newInspection = 1,
  plannedInspection = 2,
  submittedInspection = 5,
}
